import { render, staticRenderFns } from "./AsArchitectView.vue?vue&type=template&id=4ca5b069&scoped=true"
import script from "./AsArchitectView.vue?vue&type=script&lang=js"
export * from "./AsArchitectView.vue?vue&type=script&lang=js"
import style0 from "./AsArchitectView.vue?vue&type=style&index=0&id=4ca5b069&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5b069",
  null
  
)

export default component.exports